import React, { useState } from 'react'
import './LookupTable.scss'
import { MouseDownContext } from './mouseDownContext'
import { Icon } from 'semantic-ui-react'
import styled from '@emotion/styled'
import { useTable, useSortBy, Column } from 'react-table'

interface Props {
  columns: Column[]
  data: {}[]
  isBatchLookup: boolean
}

const WideSpan = styled.span([
  {
    float: 'left',
    width: 20,
  },
])

export const LookupTable: React.FC<Props> = ({ columns, data, isBatchLookup }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data,
      // @ts-ignore
      autoResetSortBy: false,
      initialState: {
        hiddenColumns: isBatchLookup ? ['Copy'] : [],
      },
    },
    useSortBy
  )

  const [isMouseDown, setIsMouseDown] = useState(false)

  return (
    <MouseDownContext.Provider value={isMouseDown}>
      <table
        {...getTableProps()}
        className="ui striped very basic table"
        onMouseDown={() => setIsMouseDown(true)}
        onMouseUp={() => setIsMouseDown(false)}
        onMouseLeave={() => setIsMouseDown(false)}
      >
        <thead>
          {headerGroups.map((headerGroup: any) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column: any) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <Icon disabled name="angle down" />
                      ) : (
                        <Icon disabled name="angle up" />
                      )
                    ) : (
                      <WideSpan />
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map(
            (row: any, i: any) =>
              // @ts-ignore
              prepareRow(row) || (
                <tr
                  // Using an ID for this is less than ideal,
                  // but it's the only way to override the striped class of the table
                  id={row.original.preSelected ? 'highlighted-row' : null}
                  {...row.getRowProps()}
                  className={row.original.attributes.removal_status ? 'visually-disabled' : null}
                >
                  {row.cells.map((cell: any) => {
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  })}
                </tr>
              )
          )}
        </tbody>
      </table>
    </MouseDownContext.Provider>
  )
}
